import React from 'react'
import styles from './Comment.scss'
import { Transition } from 'react-transition-group'
import { withTranslation } from '@hocs'

const scoreTexts = ['拍起來', '唉唷不錯', '滿喜歡的', '還想再去', '爆讚好吃', '我的天哪']

const transitionStyles = {
  entering: { opacity: 1, display: 'block' },
  entered: { opacity: 1, display: 'block' },
  exiting: { opacity: 0, display: 'block' },
  exited: { opacity: 0, display: 'none' },
}

class Comment extends React.Component {
  constructor() {
    super()
    this.state = {
      score: 0,
      isAnimating: false,
      text: '',
    }
  }

  componentDidMount() {
    const { comment } = this.props
    if (comment) {
      this.setState({
        score: comment.clap,
        text: comment.text,
      })
    }
  }

  render() {
    const { t } = this.props
    return (
      <div className="commentPop__wrapper commentPop__wrapper--comment">
        <style jsx>{styles}</style>
        <div className="commentPop__content commentPop__content--comment">
          <div className="commentPop__clapArea clapArea">
            <span
              className={`clapArea__count ${
                this.state.score > 0 ? 'clapArea__count--highlight' : ''
              }  ${this.state.isAnimating ? '.clapArea__count--jump' : ''}`}
            >
              +{this.state.score}
            </span>
            <span className="clapArea__text">{t(scoreTexts[this.state.score])}</span>
            <div
              className={`clapArea__clap ${
                this.state.score > 0 ? 'clapArea__clap--highlight' : ''
              }`}
              onClick={this.onClickClap}
            >
              <Transition in={this.state.isAnimating} timeout={500}>
                {(state) => (
                  <div
                    className="clapArea__hooray"
                    style={{
                      ...transitionStyles[state],
                    }}
                  />
                )}
              </Transition>
            </div>
            <span>{t('給店家拍拍手')}</span>
          </div>
          <textarea
            cols="30"
            rows="3"
            placeholder={t('說說你在這個地點的親身經驗')}
            onChange={this.onTextChange}
            value={this.state.text}
          />
        </div>
        <button className="submit full-width" onClick={this.onClickSubmit}>
          {t('提交')}
        </button>
      </div>
    )
  }

  onClickClap = () => {
    window.clearTimeout(this.timer)

    if ((this.state.score + 1) % 6 === 0) {
      this.setState({
        score: 0,
        isAnimating: false,
      })
    } else {
      this.setState({
        score: (this.state.score + 1) % 6,
        isAnimating: true,
      })
      this.timer = setTimeout(() => {
        this.setState({
          isAnimating: false,
        })
      }, 1000)
    }
  }

  onTextChange = (e) => {
    this.setState({
      text: e.target.value,
    })
  }

  onClickSubmit = () => {
    const { comment } = this.props
    const { score: clap, text } = this.state
    const newComment = { clap, text }
    if (comment) {
      newComment.replyID = comment.replyID
    }
    this.props.submit(newComment)
  }
}

export default withTranslation()(Comment)
